<template>
<div id="messages" class="clearfix">
    <div class="profilemain-region clearfix col-xs-120">
        <div class="wrapper clearfix">

            <div class="motorshow-categories">
                <button :class="params === 0 ? 'category-all categories -active' : 'category-all categories'" @click="params = 0">Новые</button>
                <button :class="params === 1 ? 'category-refused categories -active' : 'category-refused categories'" @click="params = 1">Предложение отправлено</button>
                <button :class="params === 2 ? 'category-accepted categories -active' : 'category-accepted categories'" @click="params = 2">В работе</button>
                <button :class="params === 21 ? 'category-accepted categories -active' : 'category-accepted categories'" @click="params = 21">Выполненные</button>
                <button :class="params === 118 ? 'category-accepted categories -active' : 'category-accepted categories'" @click="params = 118">Клиент не приехал</button>
                <button :class="params === -2 ? 'category-accepted categories -active' : 'category-accepted categories'" @click="params = -2">Отказанные</button>
                <button :class="params === -1 ? 'category-refused categories -active' : 'category-refused categories'" @click="params = -1">Скрытые</button>
            </div>
            <div class="motorshowoffers-region col-md-120">
                <div class="motorshowoffer-region">
                    <div class="motorshowoffer-main" v-for="(lead, index) in leads" :key="lead.id" :data-status="lead.status" v-if="params === lead.lead_status || (lead.lead_status !== 21 && lead.lead_status !== 118 && params === lead.status)">
                        <div class="motorshowoffer-header motorshowofferheader-nomargin">
                            <div class="motorshow-preview motorshowpreview-padding">
                                <div class="motorshow-offername">
                                        <span class="motorshowoffercontent">{{lead.job}}</span>
                                </div>
                                <div class="motorshow-autoinformation">
                                        <span class="autoinformation bold">
                                            Имя: <span class="model thin">{{lead.contact.name}}</span>
                                            Авто: <span class="model thin">{{lead.car}}</span>
                                            Год выпуска: <span class="year thin">{{lead.year}}</span>
                                            VIN: <span class="vin thin">{{lead.vin}}</span>
                                        </span>
                                </div>
                            </div>
                            <div class="motorshow-conditions" v-if="lead.status === 0">
                                <button class="motorshowchat" type="submit" @click="showChat(lead.id,lead.ids)">
                                    <img class="icon-chat" src="/static/img/icon-envelope.svg">ЧАТ<div v-if="lead.unread !== 0 && lead.unread !== '0'" class="amount -active">{{lead.unread}}</div>
                                </button>
                            </div>
                            <div class="motorshow-conditions" v-if="lead.status === 1">
                                <span class="motorshowprice"><b>{{lead.price}} {{city.valute}}</b></span>
                                <button type="button" class="motorshowoffered">ПРЕДЛОЖЕНИЕ ОТПРАВЛЕНО</button>
                                <button class="motorshowchat" type="submit" @click="showChat(lead.id,lead.ids)"><img class="icon-chat"
                                                                                 src="/static/img/icon-envelope.svg">ЧАТ<div v-if="lead.unread !== 0 && lead.unread !== '0'" class="amount -active">{{lead.unread}}</div></button>
                            </div>
                            <div class="motorshow-conditions" v-if="lead.status === 2 && lead.lead_status !== 118 && lead.lead_status !== 21">
                                <span class="motorshowprice"><b>{{lead.price}} {{city.valute}}</b></span>
                                <button type="button" class="motorshowoffered">ПРЕДЛОЖЕНИЕ ПРИНЯТО</button>
                                <button class="motorshowchat" type="submit" @click="showChat(lead.id,lead.ids)"><img class="icon-chat" src="/static/img/icon-envelope.svg">ЧАТ<div v-if="lead.unread !== 0 && lead.unread !== '0'" class="amount -active">{{lead.unread}}</div></button>
                            </div>

                            <div class="motorshow-conditions" v-if="lead.lead_status === 21">
                                <span class="motorshowprice"><b>{{lead.price}} {{city.valute}}</b></span>
                            </div>
                        </div>
                        <div class="underline"></div>
                        <div class="motorshow-content">
                                <span class="motorshowcontent">Заявка поступила: {{lead.create}}</span><br>
                                <span class="motorshowcontent">{{lead.desc}}</span>
                            <div v-if="lead.status !== 0">
                                Ответ: {{lead.comment}}
                            </div>
                            <div v-if="lead.status === 2">
                                Имя: {{lead.contact.name}} <br>
                                Телефон: {{lead.contact.phone}} <br>
                                Email: {{lead.contact.email}} <br>
                                Дата и время записи: {{lead.date}} {{lead.time}}
                            </div>
                        </div>
                        <div class="motorshow-images">
                            <a v-for="(image, key) in lead.images" :key="key" :href="image" target="_blank"><img class="photo photo_lead" :src="image"></a>
                        </div>
                        <div class="motorshow-fields" v-if="lead.status === 0">
                            <form action="" class="motorshow-form">
                                <div class="field -long">
                                    <input type="text" v-model="lead.comment" class="input" placeholder="Комментарий для клиента (есть вопросы или уточнения? Напишите в чат)">
                                </div>
                                <div class="field -short">
                                    <input type="number" min="0" v-model="lead.price" class="input" placeholder="Стоимость">
                                </div>
                            </form>
                        </div>
                        <div class="motorshow-buttons" v-if="lead.status === 0">
                            <button type="button" class="motorshowofferprice" @click="useLead(lead.id)">ОТПРАВИТЬ КЛИЕНТУ</button>
                            <button type="button" class="motorshowrefuse" @click="hideLead(lead.id)">СКРЫТЬ</button>
                        </div>
                        <div class="motorshow-buttons" v-if="lead.status === 2 && lead.lead_status !== 118 && lead.lead_status !== 21">
                            <button type="button" class="motorshowofferprice" @click="setStatus(lead.ids, 21, index)">Ремонт завершен</button>
                            <button type="button" class="motorshowrefuse" @click="setStatus(lead.ids, 118, index)">Клиент не приехал</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <chat  :user.sync="user" :city.sync="city" :auth.sync="auth" :service.sync="service" :leads.sync="leads" :chat_id.sync="chat_id" :lead_id.sync="lead_id" v-if="chat_id !== 0" />
</div>
</template>

<script>
import chat from './chat'
import axios from '@/router/http'
export default {
  name: 'messages',
  props: ['city', 'user', 'auth', 'service', 'leads'],
  data () {
    return {
      params: 0,
      chat_id: 0,
      lead_id: 0
    }
  },
  created () {
  },
  components: {
    chat
  },
  methods: {
    showChat (id, ids) {
      this.chat_id = id
      this.lead_id = ids
    },
    hideLead (id) {
      for (var key in this.leads) {
        if (this.leads[key].id === id) {
          this.leads[key].status = -1
          axios.get('https://crm.v-avtoservice.com/list/hide-service-lead?uid=' + this.user.uid + '&lead=' + id)
        }
      }
    },
    useLead (id) {
      for (var key in this.leads) {
        if (this.leads[key].id === id) {
          if (!this.leads[key].price) alert('Укажите цену работы')
          else {
            this.leads[key].status = 1
            axios.post('https://crm.v-avtoservice.com/list/use-service-lead?uid=' + this.user.uid + '&lead=' + id, JSON.stringify({
              price: this.leads[key].price,
              comment: this.leads[key].comment
            }), {crossDomain: true, headers: {'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json'}})
          }
        }
      }
    },
    setStatus (id, status, key) {
      this.leads[key].status = status
      axios.post('https://crm.v-avtoservice.com/list/save-service-lead?uid=' + this.user.uid + '&lead=' + id, JSON.stringify({
        status: status
      }), {crossDomain: true, headers: {'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json'}})
    }
  }
}
</script>

<style scoped>
.photo_lead {
    width: calc(100%/6);
    margin: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/cabinet/service/messages.vue